// Homepage Variant Fix - Theme Compatible Version
console.log('Homepage Variant Fix Started');

// Theme ke native variant system ka wait karo
function waitForThemeVariantSystem() {
  // Check karo agar theme ka variant system load hai
  if (typeof VariantPicker !== 'undefined') {
    initCompatibleVariantFix();
  } else {
    // Agar nahi hai toh thoda wait karo
    setTimeout(waitForThemeVariantSystem, 500);
  }
}

function initCompatibleVariantFix() {
  console.log('Theme variant system found, initializing compatible fix...');
  
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  console.log('Found product forms:', productForms.length);
  
  productForms.forEach((form, index) => {
    const variantSelect = form.querySelector('select[name="id"]');
    
    if (variantSelect) {
      console.log('Adding listener to form', index);
      
      // Theme ke native system ke saath compatible event listener
      variantSelect.addEventListener('change', function(e) {
        e.stopPropagation(); // Important: Theme ke events ko interfere na kare
        
        const variantId = this.value;
        console.log('Variant selected:', variantId);
        
        // Image change function call karo
        tryToChangeImage(form, variantId);
      });
    }
  });
}

function tryToChangeImage(form, variantId) {
  // Product card dhundho
  const productCard = form.closest('[data-product-handle], .product-card, .grid__item');
  
  if (!productCard) {
    console.log('Product card not found for image change');
    return;
  }
  
  // Image dhundho - different possible selectors try karo
  const imageSelectors = [
    '.product-card__image img',
    '.card__image img', 
    'img[data-product-image]',
    '.media img'
  ];
  
  let productImage = null;
  
  for (const selector of imageSelectors) {
    productImage = productCard.querySelector(selector);
    if (productImage) break;
  }
  
  if (productImage) {
    console.log('Product image found, applying effect...');
    
    // ✅ TEMPORARY EFFECT - Image ko blink karo
    productImage.style.transition = 'all 0.5s ease';
    productImage.style.opacity = '0.5';
    productImage.style.border = '2px solid red';
    
    // 1 second baad wapas normal
    setTimeout(() => {
      productImage.style.opacity = '1';
      productImage.style.border = 'none';
    }, 1000);
    
  } else {
    console.log('No product image found in card');
  }
}

// Page load pe start karo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForThemeVariantSystem);
} else {
  waitForThemeVariantSystem();
}